import { Image } from "expo-image";

import UserApiBase from "../../base/UserApiBase";

import { type AppUserSession } from "@/schemas/auth/session";
import type { UserFeedResponse } from "@/schemas/user/feed";

export async function preLoadImagesOnStartup(
  session: AppUserSession,
): Promise<void> {
  const feedService = new FeedService(session);
  const response = await feedService.getUserFeed();
  const imageUrls = response.items.map(
    (item) => item.image.image.attributes.previewUrl,
  );
  await Promise.all(imageUrls.map((url) => Image.prefetch(url)));
}

class FeedService extends UserApiBase {
  public constructor(session: AppUserSession) {
    super("/feed", session);
  }

  public getUserFeed(): Promise<UserFeedResponse> {
    return this.get<UserFeedResponse>("/items?limit=5");
  }

  public markItemAsSeen(itemId: string): Promise<void> {
    return this.post<void>(`/visited/${itemId}`, {});
  }
}

export default FeedService;
